

	var vintageArtificialHeader = false;
	var productCarousel;

	(function ($) {

	'use strict';
	productCarousel = Swiper;
	var productCarouselColors = Swiper;
	var init = false;
	var initColor = false;

	window.ald = {
		/**
		* Init Function
		*/
		init: function () {

$('.shopify-challenge__message').text('Solve Captcha to continue')

			ald.resizeAnimation();
			ald.menu();
			ald.heroVideo();
			ald.carousel();
			ald.plpToolbar();
			ald.productMainCarousel();
			ald.productVariantCarousel();
			$(window).on('resize', function() {
				ald.productMainCarousel();
				ald.productVariantCarousel();
			});
			ald.accordion();
      ald.scrollToSection();
      ald.responsiveElements();
      ald.filterMenu();
      ald.categoryMenu();
      ald.sortingMenu();
     	ald.countryProvinceSelector();
     	ald.orders();
      ald.reservations();

    	if(window.location.pathname === '/account/addresses') {
				var hash = window.location.hash;
				if(hash === '') {
					window.location = '/account/#manage-addresses';
				} else {
					console.log('>>>>')
					$(hash).show();	
          $('.loading-filters-wrapper').hide();
				}
				
			}
		},
		/**
		* Resize Animation
		*/
		resizeAnimation: function() {
			var resizeTimer;
			window.addEventListener("resize", () => {
			  document.body.classList.add("resize-animation-stopper");
			  clearTimeout(resizeTimer);
			  resizeTimer = setTimeout(() => {
			    document.body.classList.remove("resize-animation-stopper");
			  }, 400);
			});
		},
		/**
		* Menu
		*/
		menu: function() {
			$(window).on('scroll', function() {
				var header = $('.header:not(.header--no-fixed)');
				if ($(window).scrollTop() > 0) {
					header.addClass('header--fixed');
					$('.top-bar:not(.top-bar--no-fixed)').addClass('top-bar--fixed');
					$('.template-index .announcement-bar').addClass('announcement-bar--fixed');
				} else {
					header.removeClass('header--fixed');
					$('.top-bar:not(.top-bar--no-fixed)').removeClass('top-bar--fixed');
					$('.template-index .announcement-bar').removeClass('announcement-bar--fixed');
				}
				
				if(header.length < 1) {
					var noFixedHeader = $('.header--no-fixed');
					if ($(window).scrollTop() > 0) {
						noFixedHeader.addClass('header--no-fixed-scrolled');
					} else {
						noFixedHeader.removeClass('header--no-fixed-scrolled');
					}
				}
			});

			var toggleMenu = $('.menu-toggle');
			toggleMenu.on('click', function() {
				$(this).toggleClass('active-menu-toggle');
				// $('.template-index--light-header .header').toggleClass('header--light');
				$('.nav').toggleClass('nav-collapse');
        if($('body').hasClass('page-store-new-york') || $('body').hasClass('page-store-london')) {
          $('header').toggleClass('header--invert');
        }
				$('body').removeClass('search-visible').toggleClass('menu-collapse');
				/* Search on desktop */
				$('.search-visible').removeClass('search-visible');
				$('.search-collapse').removeClass('search-collapse');
				$('.header--search').removeClass('header--search');
				/* Accessibility Menu */
				$('.popup-a--visible').removeClass('popup-a--visible');
				return false;
			});
			
			var trackMenuLinks = function () {
				var $menuLinks = $('.main-nav__link, .footer-nav__link');
				
				$menuLinks.on('click', function (e) {
					if(typeof gtag === 'function') {
						var $link = $(this);
						gtag('event', 'Menu link', {
							name: $link.text(),
							href: $link.attr('href')
						})
					}
				})
			}
			
			trackMenuLinks();

			var closeTopBanner = $('.close-announcement-bar');
			closeTopBanner.on('click', function() {
				$('body').removeClass('announcement-bar-visible');
				$('.announcement-bar').hide();
			});

			var menuClose = $('.main-wrapper, .close-menu-toggle');
			menuClose.on('click', function() {
				$('.active-menu-toggle').removeClass('active-menu-toggle');
				$('.nav').removeClass('nav-collapse');
        if($('body').hasClass('page-store-new-york') || $('body').hasClass('page-store-london')) {
          $('header').addClass('header--invert');
        }
				$('body').removeClass('menu-collapse');
			});

			/* Search */
			// var searchOpen = $('.search-toggle');
			// searchOpen.on('click', function() {
			// 		$('.search-desktop').toggleClass('search-collapse');
			// 		$('.header').toggleClass('header--search');
			// 		$('body').removeClass('menu-collapse').toggleClass('search-visible');
			// 		$('.search-desktop .search-field').focus();
			// 		/* Main Menu */
			// 		$('.nav-collapse').removeClass('nav-collapse');
			// 		$('.active-menu-toggle').removeClass('active-menu-toggle');
			// 		/* Accessibility Menu */
			// 		$('.popup-a--visible').removeClass('popup-a--visible');
			// 		return false;
			// });

			// var searchClose = $('.search-close');
			// searchClose.on('click', function() {
			// 	$(this).closest('.search-desktop').removeClass('search-collapse');
			// 	$('.header').removeClass('header--search');
			// 	$('body').removeClass('search-visible');
			// 	return false;
			// });
		},
		/**
		* Hero Video
		*/
		heroVideo: function() {
			function videoResize() {
				var videos = $('.hero__video--video');


				videos.each(function() {
					var video = $(this);
					console.log('vid', video);
					if (video !== null) {
						var wrapperWidth = window.outerWidth,
						videoWidth = video[0].offsetWidth,
						videoHeight = video[0].offsetHeight; //this is to get around the elastic url bar on mobiles like ios...

						if (wrapperWidth < 1024) {
							var wrapperHeight = window.innerHeight + 100;
						} else {
							var wrapperHeight = window.innerHeight;
						}
						var scale = Math.max(wrapperWidth / videoWidth, wrapperHeight / videoHeight);
						scale = Math.ceil(scale * 100) / 100;
						var css = "translate(-50%, -50%) " + "scale(" + scale + ")";
						console.log(css);
						video.css('transform', css);
					}
				})

			}
			videoResize();
			window.onresize = function (event) {
				videoResize();
			};
		},
		/**
		* Carousel
		*/
		carousel: function() {
			/* Index Carousel */
			if($('.carousel').length) {
				var slidePerViewDesktop = parseInt($('.carousel').data('slides-per-row'));
				var indexCarousel = new Swiper('.carousel', {
					spaceBetween: 7,
					slidesPerView: 'auto',
					breakpoints: {
	        	1024: {
		          slidesPerView: slidePerViewDesktop,
		          spaceBetween: 14,
		          watchOverflow: true,
		           navigation: {
				        nextEl: '.carousel-button-next',
				        prevEl: '.carousel-button-prev',
				      },
		        }
		      }
				});
			}

			/* Editorial Carousel */
			if($('.editorial-carousel').length) {

				var indexCarousel = new Swiper('.editorial-carousel', {
					spaceBetween: 7,
					slidesPerView: 'auto',
					pagination: {
						el: '.swiper-pagination',
					},
					breakpoints: {
						1024: {
							slidesPerView: 'auto',
							spaceBetween: 14,
							watchOverflow: true,
							navigation: {
								nextEl: '.editorial-carousel-button-next',
								prevEl: '.editorial-carousel-button-prev',
							},
						}
					}
				});
			}

			if($('.cafe-carousel').length) {
				var cafeMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
				var cafeDesktop = window.matchMedia('(min-width: 1025px)');
				if(cafeMobile.matches) {
					if(!init) {
						init = true;
						var cafeCarousel = new Swiper('.cafe-carousel', {
							spaceBetween: 14,
							slidesPerView: 'auto',
						});
					}
				} else if(cafeDesktop.matches ) {
					if(typeof cafeCarousel === 'object') {
						cafeCarousel.destroy();
						init = false;
					}
				}
			}

			if ($('.cafe-carousel-hero .swiper-slide').length > 1) {
				if($('.cafe-carousel-hero').length) {
					var slidesSpeed = parseInt($('.cafe-carousel-hero').data('slides-speed'));
					var announcementCarousel = new Swiper('.cafe-carousel-hero', {
					 	effect: "fade",
					  speed: slidesSpeed,
					  loop: true,
					  autoplay: true,
					  watchOverflow: true,
					  fadeEffect: { crossFade: true },
					  slidesPerView: 1,
					});
				}
			}

			if ($('.cafe-carousel-bottom .swiper-slide').length > 1) {
				if($('.cafe-carousel-bottom').length) {
					var cafeCarousel = new Swiper('.cafe-carousel-bottom', {
					 	spaceBetween: 20,
						slidesPerView: 'auto',
						breakpoints: {
		        	1024: {
		        		slidesPerView: 'auto',
			          spaceBetween: 20,
			          watchOverflow: true,
			        }
			      }
					});
				}
			}

			/* Brand Carousel */
			if($('.source-carousel').length) {
				var brandCarousel = new Swiper('.source-carousel', {
					spaceBetween: 10,
					slidesPerView: 'auto',
					breakpoints: {
	        	1024: {
	        		slidesPerView: 'auto',
		          spaceBetween: 10,
		          watchOverflow: true,
		        }
		      }
				});
			}

			if ($('.slideshow-media .swiper-slide').length > 1) {
				if($('.slideshow-media').length) {
					var slidesSpeed = parseInt($('.cafe-carousel-hero').data('slides-speed'));
					var slideshowSection = new Swiper('.slideshow-media', {
					 	spaceBetween: 10,
						slidesPerView: 'auto',
						breakpoints: {
		        	1024: {
		        		slidesPerView: 'auto',
			          spaceBetween: 20,
			          watchOverflow: true,
			        }
			      }
					});
				}
			}

			// if ($('.store-gallery .swiper-slide').length > 1) {
			// 	if($('.store-gallery').length) {
			// 		var slideshowSection = new Swiper('.store-gallery', {
			// 			slidesPerView: 1,
			// 				pagination: {
			// 				el: '.swiper-pagination',
			// 			},
			// 			navigation: {
			// 				nextEl: '.story-gallery-button-next',
			// 				prevEl: '.story-gallery-button-prev',
			// 			},
			// 		});
			// 	}
			// }
		},
		/**
		* Toolbar
		*/
    plpToolbar: function() {
      var viewMobile = $('.toolbar-mobile');
      var currentViewMobile = $(viewMobile).find('[data-view]');
if($(window).width() <= 1024) {
	$('.plp-carousel').addClass('plp-carousel--active');
      if(localStorage.getItem('plpmobile') === '1') {
      	console.log('switch 1')
        $('.products-collection').addClass('grid-products--one');
        console.log('switch 2')
        $('.active-toolbar-columns').removeClass('active-toolbar-columns');
        console.log('switch 3')
        $('.toolbar-mobile div:first-child').removeClass('active-toolbar-columns');
        console.log('switch 4')
        $('.toolbar-mobile div:last-child').addClass('active-toolbar-columns');
      }

      if(localStorage.getItem('plpmobile') === '2') {
        $('.products-collection').addClass('grid-products--four').removeClass('grid-products--one grid-products--four-mobile');
      }

      if(localStorage.getItem('plpmobile') === '4') {
        $('.products-collection').addClass('grid-products--four-mobile').removeClass('grid-products--one');;
        $('.active-toolbar-columns').removeClass('active-toolbar-columns');
        $('.toolbar-mobile div:first-child').addClass('active-toolbar-columns');
      }
      
      $('.plp-carousel').removeClass('plp-carousel--active');
      $('.plp-carousel').scrollLeft(0);
    }
if($(window).width() > 1024) {
      if(localStorage.getItem('plpdesktop') === '3') {
        $('.products-collection').removeClass('grid-products--four');
        $('.products-collection').addClass('grid-products--eight');
        $('.toolbar-desktop .toolbar__columns-size').removeClass('active-toolbar-columns');
        $('.toolbar-desktop .toolbar__columns-size-wide').addClass('active-toolbar-columns');

      // $('.plp-artificial').show();

      }

      if(localStorage.getItem('plpdesktop') === '5') {
		$('.products-collection').addClass('grid-products--four');
	    $('.products-collection').removeClass('grid-products--eight').removeClass('grid-products--two');
      }

      if(localStorage.getItem('plpdesktop') === '2') {
        $('.products-collection').removeClass('grid-products--four');
        $('.products-collection').addClass('grid-products--two');
        $('.toolbar-desktop .toolbar__columns-size').removeClass('active-toolbar-columns');
        $('.toolbar-desktop .toolbar__columns-size-thin').addClass('active-toolbar-columns');
      }
    }

      currentViewMobile.on('click', function() {
        if($('.toolbar-mobile .active-toolbar-columns').length && !$(this).hasClass('active-toolbar-columns'))  {
          $('.toolbar-mobile .active-toolbar-columns').removeClass('active-toolbar-columns');
        }
        var viewTypeMobile = $(this).data('view');
        $('.plp-carousel').addClass('plp-carousel--active');
        if(viewTypeMobile === 'columns-size-one') {
          localStorage.setItem('plpmobile', 1);
          $('.products-collection').addClass('grid-products--one');
          $('.products-collection').removeClass('grid-products--four-mobile')
          $(this).addClass('active-toolbar-columns');
        } else if(viewTypeMobile === 'columns-size-normal') {
          localStorage.setItem('plpmobile', 2);
          $('.products-collection').removeClass('grid-products--one');
          $('.products-collection').removeClass('grid-products--four-mobile')
          $(this).addClass('active-toolbar-columns');
        } else if(viewTypeMobile === 'columns-size-wide') {
          localStorage.setItem('plpmobile', 4);
          $('.products-collection').addClass('grid-products--four-mobile')
          $('.products-collection').removeClass('grid-products--one');
          $(this).addClass('active-toolbar-columns');
        }

        /* reset carousel */
        $('.plp-carousel').each(function() {
        	if($(this).scrollLeft() != 0) {
        		var currWidth = $(this).width();
        		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
        	}
        });
        /* reset carousel */

		    if(typeof gtag === 'function') {
          var valueMappingMobile = {
            'columns-size-one': '1-across',
            'columns-size-normal': '2-across',
            'columns-size-wide': '4-across',
          }
          var valueMappingMobileCategory = {
            "columns-size-one": "1",
            "columns-size-normal": "2",
            "columns-size-wide": "4",
          };
          gtag('event', 'Filtering Mobile View Options', {
            'filter_value': valueMappingMobile[viewTypeMobile] || viewTypeMobile,
          })

          // category events
          const categoryTitle = $('.category-menu-toggle').text().trim();
          gtag('event', `${categoryTitle}_View Option_${valueMappingMobileCategory[viewTypeMobile] || viewTypeMobile}`);
        }

        $('.plp-carousel').scrollLeft(0);
        $('.plp-carousel').removeClass('plp-carousel--active');

      });

      var viewDesktop = $('.toolbar-desktop');
      var currentViewDesktop = $(viewDesktop).find('[data-view]');
      currentViewDesktop.on('click', function() {
        if($('.toolbar-desktop .active-toolbar-columns').length && !$(this).hasClass('active-toolbar-columns'))  {
          $('.toolbar-desktop .active-toolbar-columns').removeClass('active-toolbar-columns');
        }
        var viewTypeDesktop = $(this).data('view');
        if(viewTypeDesktop === 'columns-size-three') {
          localStorage.setItem('plpdesktop', 3);
          $('.products-collection').addClass('grid-products--eight');
          $('.products-collection').removeClass('grid-products--four').removeClass('grid-products--two');
          $(this).addClass('active-toolbar-columns');

          $('.plp-artificial').show();

        } else if(viewTypeDesktop === 'columns-size-normal') {
          localStorage.setItem('plpdesktop', 5);
          $('.products-collection').addClass('grid-products--four');
          $('.products-collection').removeClass('grid-products--eight').removeClass('grid-products--two');
          $(this).addClass('active-toolbar-columns');

    // if($('.grid-products').hasClass('grid-products--four')) {
      $('.plp-artificial').eq(4).hide();
      $('.plp-artificial').eq(3).hide();
    // }

        } else if(viewTypeDesktop === 'columns-size-two') {
          localStorage.setItem('plpdesktop', 2);
          $('.products-collection').addClass('grid-products--two');
          $('.products-collection').removeClass('grid-products--eight').removeClass('grid-products--four');
          $(this).addClass('active-toolbar-columns');
        }

        /* reset carousel */
        $('.plp-carousel').each(function() {
        	if($(this).scrollLeft() != 0) {
        		var currWidth = $(this).width();
        		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
        	}
        });
        /* reset carousel */

		  if(typeof gtag === 'function') {
			  var valueMappingDesktop = {
				  'columns-size-two': '2-across',
				  'columns-size-normal': '4-across',
				  'columns-size-three': '8-across',
			  }
			  var valueMappingDesktopCategory = {
				"columns-size-two": "2",
				"columns-size-normal": "4",
				"columns-size-three": "8",
			  };
			  gtag('event', 'Filtering Desktop View Options', {
				  'filter_value': valueMappingDesktop[viewTypeDesktop] || viewTypeDesktop,
			  })

			  // category events
			  const categoryTitle = $('.category-menu-toggle').text().trim();
			  gtag('event', `${categoryTitle}_View Option_${valueMappingDesktopCategory[viewTypeDesktop] || viewTypeDesktop}`);
		  }
      });
    },
		/**
		* Product Carousel
		*/
		productMainCarousel: function() {
			if($('.product__carousel').length) {
				var mobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
				var desktop = window.matchMedia('(min-width: 1025px)');
				if(mobile.matches) {
					if(!init) {
						init = true;
						productCarousel = new Swiper('.product__carousel', {
							pagination: {
								el: '.swiper-pagination',
							},
						});
					}
				} else if(desktop.matches ) {
					if(typeof productCarousel === 'object') {
						productCarousel.destroy();
						init = false;
					}
				}
			}

			if($('.product__carousel-new').length) {
				var mobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
				var desktop = window.matchMedia('(min-width: 1025px)');
console.log('>> swiper test')
				if(mobile.matches) {
console.log('>> swiper test mobile')
					if(!init) {
						init = true;
						productCarousel = new Swiper('.product__carousel-new', {
							effect: 'fade',
							loop: true,
						  fadeEffect: {
						    crossFade: true
						  },
							pagination: {
								el: '.swiper-pagination',
							},
							on: {
								slideChange: function () {
									this.slides.forEach((el) => {
										const videoElement = $(el).find('video')[0];
										
										if(videoElement) {
											const wasActive = $(el).hasClass('swiper-slide-active');
											if(wasActive) {
												videoElement?.pause();
											} else {
												videoElement?.play();
											}
										}
									});
								},
								init: function () {
									this.slides.forEach((el, i) => {
										if(i > 0) {
											const videoElement = $(el).find('video')[0];
											if(videoElement) videoElement?.pause();
										}
									});
								}
							}
						});
					}
				} else if(desktop.matches ) {
console.log('>> swiper test desktop')
					if(typeof productCarousel === 'object') {
						productCarousel.destroy();
						init = false;
					}
				}
			}
			
		},
		/**
		* Product Variant Carousel
		*/
		productVariantCarousel: function() {
			if($('.swatch-colors').length) {
				var mobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
				var desktop = window.matchMedia('(min-width: 1025px)');
				if(mobile.matches) {
					if(!initColor) {
						initColor = true;
						productCarouselColors = new Swiper('.swatch-colors', {
							spaceBetween: 7,
							slidesPerView: 'auto',
					 	 	navigation: {
				        nextEl: '#swatch-colors-next',
				        prevEl: '#swatch-colors-prev',
				      },
						});
					}
				}

				else if(desktop.matches ) {
					if(typeof productCarouselColors === 'object') {
						productCarouselColors.destroy();
						initColor = false;
					}
				}
			}
		},
		/**
		* Accordion
		*/
    accordion: function() {
      var panelToggle = $('.panel__toggle');
      panelToggle.on('click', function() {
        var panelContent = $(this).next('.panel__content');
        if (panelContent.css('display') === 'none') {
          panelContent.addClass('custom-scrollbar');
          panelContent.find('table').parents('li').each(function(index, el) {
            panelContent.css({ display: 'block', height: 0, overflow: 'hidden', paddingTop: 0 });

            // var simpleBarInstance = SimpleBar.instances.get(el) || new SimpleBar(el, { autoHide: false });
            // simpleBarInstance.recalculate();

            panelContent.removeAttr('style');
            panelContent.css({ display: 'none' });
          });
        }

        // Titles of drawers that we want to handle by gtag event
        var gtagDrawers = [
        	'Product Details and Sizing',
					'Delivery and Returns',
					'Product Details',
					'Sizing'
				];
        var eventAction = '';
        var eventName = '';
        if(gtagDrawers.includes($(this).text())) {
					eventName = $(this).text();
					if($(this).hasClass('active-panel-toggle')) {
						eventAction = 'Closed';
					} else {
						eventAction = 'Opened';
					}

					if(typeof gtag === 'function') {
						gtag('event', 'PDP Drawer', {
							'eventName': eventName,
							'eventAction': eventAction
						});
					}
        }

        if($(this).hasClass('active-panel-toggle')) {
					$(this).attr('aria-expanded', 'false');
				} else {
					$(this).attr('aria-expanded', 'true');
				}

        $(this).toggleClass('active-panel-toggle');
        panelContent.slideToggle();
      });
    },
    /**
    * Scroll To Section
    */
    scrollToSection: function() {
      $('.link-scroll-to').on('click', function(event) {
       var hash = this.hash;
       $('html, body').animate({
          scrollTop: $(hash).offset().top - 60
        }, 800);
       return false;
      });

      $('.link-scroll-to-deniro').on('click', function(event) {
       var hash = this.hash;
       var spacer = 110;
       if(hash == '#shop') {
       	spacer = 60;
       }
       $('html, body').animate({
          scrollTop: $(hash).offset().top - spacer
        }, 800);
       return false;
      });

     	$('.link-cafe-scroll-to').on('click', function(event) {
       var hash = this.hash;
       var xstop = 120;
       // if($(window).width() < 758) {
       // 	 xstop = 0;
       // }
       $('html, body').animate({
          scrollTop: $(hash).offset().top - xstop
        }, 800);
       return false;
      });

      if($('body').hasClass('xpage-cafe-leon-dore')) {
      	$(window).on('scroll', function() {
      		if($(window).width() > 1024) {
	      		var cafegridOffset = $('.cafe-grid').offset().top;
	      		var docOffset = $(document).scrollTop();
	      		var hght = $('.cafe-grid').outerHeight() - 80;
	      		var menuHght = 0;
	      		// $('.single-menu').each(function() {
	      		// 	menuHght += $(this).outerHeight() + parseInt($(this).css('margin-bottom'));
	      		// });

						menuHght += $('.menu-section').outerHeight() + parseInt($('.menu-section').css('margin-bottom'));

	      		var winHeight = $(window).height();

	    			var spacer = hght - menuHght;
	    			//var ratio = spacer / (docOffset - cafegridOffset + (winHeight / 2));
	    			//var ratio = 1;
	    			var ratio = spacer / hght;

	      		// console.log('>>', cafegridOffset, docOffset);
	      		if(cafegridOffset - (winHeight / 2) < docOffset) {
	      			if(docOffset + (winHeight / 2) > cafegridOffset + hght) {

	      			} else {

		      			var scrollValue = docOffset - cafegridOffset + (winHeight / 2);


		      			$('.menu-section').css('top', ratio * scrollValue);
	      			}
	      		} else {
	      			$('.menu-section').css('top', 0);
	      		}
	      	}
      	});
      }
    },
    /**
    * Responsive Elements
    */
    responsiveElements: function() {
      var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        $(this).wrap('<div class="video-wrapper"></div>');
      });
    },
    /**
    * Filter Menu
    */
    filterMenu: function() {
    	var filterToggle = $('.filter-toggle');

    	$('body').on('keyup', function(e) {
		    if (e.key === 'Escape') {
	        if($('.active-filter-toggle').length) {
	        	$('.active-filter-toggle').trigger('click');
	        }
		    }
    	});

    	filterToggle.on('keyup', function(e) {
		    if (e.key === 'Enter' || e.keyCode === 13) {
	        $('.filter-toggle').trigger('mouseover');
	        // $('.filter-toggle').trigger('click');
		    }
    	});

    	filterToggle.on('click', function() {
    		if($('.filter-menu').hasClass('filter-menu-collapse')) {
				if (typeof gtag === "function") {
				  const categoryTitle = $('.category-menu-toggle').text().trim();
				  gtag('event', `${categoryTitle}_Refine_Close`);
				}
    		} else {
    			if(typeof gtag === 'function') {
					gtag('event', 'Open Filters', {
					  'type': 'filtering',
					  'collection': $('.collection-control .breadcrumbs li:last-child').text()
					});
					const categoryTitle = $('.category-menu-toggle').text().trim();
					gtag('event', `${categoryTitle}_Refine_Expand`);
    			}

				// close category menu
				$('.category-menu').removeClass('filter-menu-collapse');
  				$('.category-menu-overlay--visible').toggleClass('category-menu-overlay--visible');
  				$('body').removeClass('category-menu-visible');
  				$('.active-category-menu-toggle').removeClass('active-category-menu-toggle');
				// close sorting menu
				$('.sorting-menu').removeClass('filter-menu-collapse');
				$('.sorting-menu-overlay--visible').toggleClass('sorting-menu-overlay--visible');
				$('body').removeClass('sorting-menu-visible');
				$('.active-sorting-menu-toggle').removeClass('active-sorting-menu-toggle');
    		}
    		$(this).toggleClass('active-filter-toggle');
    		$('.filter-menu').toggleClass('filter-menu-collapse');
    		$('.filter-menu-overlay').toggleClass('filter-menu-overlay--visible');
				setTimeout(function(){
					$('body').toggleClass('filter-menu-visible');

          /* reset carousel */
          $('.plp-carousel').each(function() {
          	if($(this).scrollLeft() != 0) {
          		var currWidth = $(this).width();
          		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
          	}
          });
          /* reset carousel */

				},300);


				/* - - - - - */

				if($(this).parent().hasClass('filters-vintage')) {
					console.log('watch out !!!', $('.collection-control').hasClass('collection-control--fixed'), vintageArtificialHeader)
					if($('.collection-control').hasClass('collection-control--fixed') && vintageArtificialHeader) {
          	$('.collection-control').removeClass('collection-control--fixed');
          	$('.header--vintage').addClass('header--light');
          	vintageArtificialHeader = false;
					} else if(!$('.collection-control').hasClass('collection-control--fixed')) {

          
          	$('.collection-control').addClass('collection-control--fixed');
          	$('.header--vintage').removeClass('header--light');
          	vintageArtificialHeader = true;

	          // var height = $(window).height();
	          // var scrollTop = $(window).scrollTop();
	          // var scrollAmount = 2 * height - 59;

	          // $('body, html').animate({
	          //     scrollTop: scrollAmount
	          // }, 750);
          }
				}

				/* - - - - - */
    	});
    	var filterVariant = $('.filter-variant');

    	$('body').on('keyup', '.filter-variant', function(e) {
		    if (e.key === 'Enter' || e.keyCode === 13) {
    			$(this).toggleClass('active-filter-variant').next().slideToggle();
    		}
    	});

    	$('body').on('click', '.filter-variant', function() {
    		$(this).toggleClass('active-filter-variant').next().slideToggle();
    	});
    	var filterCloseBody = $('.filter-menu-overlay');
    	filterCloseBody.on('click', function() {
		if (typeof gtag === "function") {
			const categoryTitle = $('.category-menu-toggle').text().trim();
			gtag('event', `${categoryTitle}_Refine_Close`);
		}

        if($(window).width() > 900) {
  				$('.filter-menu').removeClass('filter-menu-collapse');
  				$('.filter-menu-overlay--visible').toggleClass('filter-menu-overlay--visible');
  				$('body').removeClass('filter-menu-visible');
  				$('.active-filter-toggle').removeClass('active-filter-toggle');
  				$('.active-filter-variant:not(.active-filter-variant-initially)').removeClass('active-filter-variant');

          /* reset carousel */
          $('.plp-carousel').each(function() {
          	if($(this).scrollLeft() != 0) {
          		var currWidth = $(this).width();
          		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
          	}
          });
          /* reset carousel */
        }

				if(vintageArtificialHeader) {
          	$('.collection-control').removeClass('collection-control--fixed');
          	$('.header--vintage').addClass('header--light');
          	vintageArtificialHeader = false;
				}
    	});

    	$('.close-filters').on('click', function() {
			if (typeof gtag === "function") {
				const categoryTitle = $('.category-menu-toggle').text().trim();
				gtag('event', `${categoryTitle}_Refine_Close`);
			}


    		$('.filter-menu-overlay').removeClass('filter-menu-overlay--visible');
    		$('.filter-menu-collapse').removeClass('filter-menu-collapse');
    		$('body').removeClass('filter-menu-visible');

        /* reset carousel */
        $('.plp-carousel').each(function() {
        	if($(this).scrollLeft() != 0) {
        		var currWidth = $(this).width();
        		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
        	}
        });
        /* reset carousel */

    		return false;
    	});

		var lastScrollTop = 0;
		$(window).scroll(function(event){
			var collection = ('.collection-control:not(.collection-control--vintage)');
			//$(collection).removeClass('collection-control--fixed');
			var st = $(this).scrollTop();
			if (!$('.filter-menu').hasClass('filter-menu-collapse') && !$('.category-menu').hasClass('filter-menu-collapse') && st > lastScrollTop) {
				if(st > 59) {
					$(collection).addClass('collection-control--hide');
					$(collection).removeClass('collection-control--fixed');
				}
			} else {
				$(collection).addClass('collection-control--fixed');
				$(collection).removeClass('collection-control--hide');
			}
			lastScrollTop = st;
		});

      var artificalScroll = false;
          if(window.location.pathname.indexOf('collections/leon-dore') > -1) {
            console.log('> vintage');
            if(window.location.search.indexOf('page=') > -1) {
              console.log('page', window.location.search.substring(6));
              var page = parseInt(window.location.search.substring(6));
              if(page > 1) {
              	// alert($(window).width())
              	if($(window).width() < 1025) {
              		// safari (90 - chrome)
              		if($(window).width() < 768) {
              			$('html, body').scrollTop(window.innerHeight * 2 + 168);	
              		} else {
              			if(window.innerHeight > 1250) {
              				$('html, body').scrollTop(window.innerHeight * 2 + 20);	
              			} else {
              				$('html, body').scrollTop(window.innerHeight * 2 + 90);	
              			}
              			
              		}
              	} else {
              		$('html, body').scrollTop(window.innerHeight * 2 - 59);	
              	}
                
                $('.collection-control--vintage').removeClass('collection-control--fixed');

                setTimeout(function() {
              	if($(window).width() < 1025) {
              		// safari
              		if($(window).width() < 768) {
              			$('html, body').scrollTop(window.innerHeight * 2 + 168);	
              		} else {
              			if(window.innerHeight > 1250) {
              				$('html, body').scrollTop(window.innerHeight * 2 + 20);	
              			} else {
              				$('html, body').scrollTop(window.innerHeight * 2 + 90);	
              			}
              		}
              	} else {
              		$('html, body').scrollTop(window.innerHeight * 2 - 59);	
              	}
                $('.collection-control--vintage').removeClass('collection-control--fixed');
                }, 500);
                setTimeout(function() {
              	if($(window).width() < 1025) {
              		// safari
              		if($(window).width() < 768) {
              			$('html, body').scrollTop(window.innerHeight * 2 + 168);	
              		} else {
              			if(window.innerHeight > 1250) {
              				$('html, body').scrollTop(window.innerHeight * 2 + 20);	
              			} else {
              				$('html, body').scrollTop(window.innerHeight * 2 + 90);	
              			}
              		}	
              	} else {
              		$('html, body').scrollTop(window.innerHeight * 2 - 59);	
              	}
                $('.collection-control--vintage').removeClass('collection-control--fixed');
                }, 1000);

                setTimeout(function() {
              	if($(window).width() < 1025) {
              		// safari
              		if($(window).width() < 768) {
              			$('html, body').scrollTop(window.innerHeight * 2 + 168);	
              		} else {
              			if(window.innerHeight > 1250) {
              				$('html, body').scrollTop(window.innerHeight * 2 + 20);	
              			} else {
              				$('html, body').scrollTop(window.innerHeight * 2 + 90);	
              			}
              		}
              	} else {
              		$('html, body').scrollTop(window.innerHeight * 2 - 59);	
              	}
                $('.collection-control--vintage').removeClass('collection-control--fixed');
                  artificalScroll = true;
                }, 2000);

                /// scroll to section
//                        $('html, body').animate({
//           scrollTop: 1955
//         }, 100);
              }
            }
          }

			var lastScrollTopVintage = 0;
			$(window).scroll(function(event){
              if(artificalScroll) {
				var collection = ('.collection-control--vintage');

				$(collection).removeClass('collection-control--fixed');
				var st = $(this).scrollTop();
				if (st > lastScrollTopVintage) {
				 	if(st > 59) {
				 		console.log('scroll down, hide menu');
				// 		$(collection).addClass('collection-control--hide');

						var productsContainer = $('.products-collection').offset().top;
						var productHeight = $('.plp-product').eq(0).outerHeight();
						if(st - productsContainer + 120 > 0) {
							if(st - productsContainer + 120 - 2 * productHeight > 0) {
								$(collection).removeClass('collection-control--fixed');
							} else {
								$(collection).addClass('collection-control--fixed');
							}

						} else {
							$(collection).removeClass('collection-control--fixed');
						}
					}
			  } else {
			  	var productsContainer = $('.products-collection').offset().top;
			  	console.log(productsContainer);
			  	if(st - productsContainer + 120 > 0) {
				 		console.log('scroll up, hide menu')
				 		$(collection).addClass('collection-control--fixed');
			  	} else {
			  		console.log('scroll up, show menu')
			  		$(collection).removeClass('collection-control--fixed');
			  	}

				// 	$(collection).removeClass('collection-control--hide');
			  }
				lastScrollTopVintage = st;
              }
			});


    },
    /**
    * Category Menu
    */
    categoryMenu: function() {
    	var filterToggle = $('.category-menu-toggle');
		var filterToggleText = filterToggle.text().trim();

    	$('body').on('keyup', function(e) {
		    if (e.key === 'Escape') {
	        if($('.active-category-menu-toggle').length) {
	        	$('.active-category-menu-toggle').trigger('click');
	        }
		    }
    	});

    	filterToggle.on('keyup', function(e) {
		    if (e.key === 'Enter' || e.keyCode === 13) {
	        $('.category-menu-toggle').trigger('mouseover');
	        // $('.filter-toggle').trigger('click');
		    }
    	});

    	filterToggle.on('click', function() {
			if(!$('.category-menu').hasClass('filter-menu-collapse')) {
				// close filter menu
				$('.filter-menu').removeClass('filter-menu-collapse');
				$('.filter-menu-overlay--visible').removeClass('filter-menu-overlay--visible');
				$('body').removeClass('filter-menu-visible');
				$('.active-filter-toggle').removeClass('active-filter-toggle');
				$('.active-filter-variant:not(.active-filter-variant-initially)').removeClass('active-filter-variant');
				
				// close sorting menu
				$('.sorting-menu').removeClass('filter-menu-collapse');
  				$('.sorting-menu-overlay--visible').toggleClass('sorting-menu-overlay--visible');
  				$('body').removeClass('sorting-menu-visible');
  				$('.active-sorting-menu-toggle').removeClass('active-sorting-menu-toggle');

				if (typeof gtag === 'function') {
					gtag('event', `${filterToggleText}_Shop All Menu_Expand`);
				}
			} else {
				if (typeof gtag === 'function') {
					gtag('event', `${filterToggleText}_Shop All Menu_Close`);
				}
			}

    		$(this).toggleClass('active-category-menu-toggle');
    		$('.category-menu').toggleClass('filter-menu-collapse');
    		$('.category-menu-overlay').toggleClass('category-menu-overlay--visible');
				setTimeout(function(){
					$('body').toggleClass('category-menu-visible');

          /* reset carousel */
          $('.plp-carousel').each(function() {
          	if($(this).scrollLeft() != 0) {
          		var currWidth = $(this).width();
          		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
          	}
          });
          /* reset carousel */

				},300);
    	});

		var filterCloseBody = $('.category-menu-overlay');
    	filterCloseBody.on('click', function() {
		if (typeof gtag === 'function') {
			gtag('event', `${filterToggleText}_Shop All Menu_Close`);
		}
        if($(window).width() > 900) {
  				$('.category-menu').removeClass('filter-menu-collapse');
  				$('.category-menu-overlay--visible').toggleClass('category-menu-overlay--visible');
  				$('body').removeClass('category-menu-visible');
  				$('.active-category-menu-toggle').removeClass('active-category-menu-toggle');
  				$('.active-filter-variant:not(.active-filter-variant-initially)').removeClass('active-filter-variant');

          /* reset carousel */
          $('.plp-carousel').each(function() {
          	if($(this).scrollLeft() != 0) {
          		var currWidth = $(this).width();
          		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
          	}
          });
          /* reset carousel */
        }

				if(vintageArtificialHeader) {
          	$('.collection-control').removeClass('collection-control--fixed');
          	$('.header--vintage').addClass('header--light');
          	vintageArtificialHeader = false;
				}
    	});

    	$('.close-category-menu').on('click', function() {
			if (typeof gtag === 'function') {
			  gtag('event', `${filterToggleText}_Shop All Menu_Close`);
			}

    		$('.category-menu-overlay').removeClass('category-menu-overlay--visible');
    		$('.filter-menu-collapse').removeClass('filter-menu-collapse');
    		$('.category-menu-toggle').removeClass('active-category-menu-toggle');
    		$('body').removeClass('category-menu-visible');

        /* reset carousel */
        $('.plp-carousel').each(function() {
        	if($(this).scrollLeft() != 0) {
        		var currWidth = $(this).width();
        		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
        	}
        });
        /* reset carousel */

    		return false;
    	});
    },
    /**
    * Sorting Menu
    */
    sortingMenu: function() {
    	var filterToggle = $('.sorting-menu-toggle');

    	$('body').on('keyup', function(e) {
		    if (e.key === 'Escape') {
	        if($('.active-sorting-menu-toggle').length) {
	        	$('.active-sorting-menu-toggle').trigger('click');
	        }
		    }
    	});

    	filterToggle.on('keyup', function(e) {
		    if (e.key === 'Enter' || e.keyCode === 13) {
	        	$('.sorting-menu-toggle').trigger('mouseover');
		    }
    	});

    	filterToggle.on('click', function() {
			if(!$('.sorting-menu').hasClass('filter-menu-collapse')) {
				if (typeof gtag === "function") {
				  const categoryTitle = $('.category-menu-toggle').text().trim();
				  gtag('event', `${categoryTitle}_Sort Filter_Expand`);
				}

				// close filter menu
				$('.filter-menu').removeClass('filter-menu-collapse');
				$('.filter-menu-overlay--visible').removeClass('filter-menu-overlay--visible');
				$('body').removeClass('filter-menu-visible');
				$('.active-filter-toggle').removeClass('active-filter-toggle');
				$('.active-filter-variant:not(.active-filter-variant-initially)').removeClass('active-filter-variant');
				
				// close category menu
				$('.category-menu').removeClass('filter-menu-collapse');
  				$('.category-menu-overlay--visible').toggleClass('category-menu-overlay--visible');
  				$('body').removeClass('category-menu-visible');
  				$('.active-category-menu-toggle').removeClass('active-category-menu-toggle');
    		} else {
				if (typeof gtag === "function") {
					const categoryTitle = $('.category-menu-toggle').text().trim();
					gtag('event', `${categoryTitle}_Sort Filter_Close`);
				}
			}

    		$(this).toggleClass('active-sorting-menu-toggle');
    		$('.sorting-menu').toggleClass('filter-menu-collapse');
    		$('.sorting-menu-overlay').toggleClass('sorting-menu-overlay--visible');
				setTimeout(function(){
					$('body').toggleClass('sorting-menu-visible');

          /* reset carousel */
          $('.plp-carousel').each(function() {
          	if($(this).scrollLeft() != 0) {
          		var currWidth = $(this).width();
          		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
          	}
          });
          /* reset carousel */

				},300);
    	});

		var filterCloseBody = $('.sorting-menu-overlay');
    	filterCloseBody.on('click', function() {
		if (typeof gtag === "function") {
			const categoryTitle = $('.category-menu-toggle').text().trim();
			gtag('event', `${categoryTitle}_Sort Filter_Close`);
		}
        if($(window).width() > 900) {
  				$('.sorting-menu').removeClass('filter-menu-collapse');
  				$('.sorting-menu-overlay--visible').toggleClass('sorting-menu-overlay--visible');
  				$('body').removeClass('sorting-menu-visible');
  				$('.active-sorting-menu-toggle').removeClass('active-sorting-menu-toggle');
  				$('.active-filter-variant:not(.active-filter-variant-initially)').removeClass('active-filter-variant');

          /* reset carousel */
          $('.plp-carousel').each(function() {
          	if($(this).scrollLeft() != 0) {
          		var currWidth = $(this).width();
          		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
          	}
          });
          /* reset carousel */
        }

				if(vintageArtificialHeader) {
          	$('.collection-control').removeClass('collection-control--fixed');
          	$('.header--vintage').addClass('header--light');
          	vintageArtificialHeader = false;
				}
    	});

    	$('.close-sorting-menu').on('click', function() {

    		$('.sorting-menu-overlay').removeClass('sorting-menu-overlay--visible');
    		$('.filter-menu-collapse').removeClass('filter-menu-collapse');
    		$('.sorting-menu-toggle').removeClass('active-sorting-menu-toggle');
    		$('body').removeClass('sorting-menu-visible');

        /* reset carousel */
        $('.plp-carousel').each(function() {
        	if($(this).scrollLeft() != 0) {
        		var currWidth = $(this).width();
        		$(this).scrollLeft(parseInt($(this).data('imgidx')) * currWidth);
        	}
        });
        /* reset carousel */

    		return false;
    	});
    },
   	/**
    * Country Province
    */
  	countryProvinceSelector: function() {
			$('.address-country-option').on('change', function() {
				var provinces = $(this).find(':selected').data('provinces');
				console.log(provinces);
				if(provinces != undefined) {
					if(provinces.length > 0) {
						$('.province-select').find('option').remove();
						$('.province-select').show().attr('disabled', false);
						if($('.province-select').attr('data-superdisabled') == '1') {
							$('.province-select').show().attr('disabled', true);
						}						
						$('.province-input').hide().attr('disabled', true);
						for(var i in provinces) {
							$('.province-select').append('<option name="'+provinces[i][0]+'">'+provinces[i][0]+'</option>');
						}
	          var selected_province = $('.province-select:visible').data('default');
	          console.log('selected province', selected_province);
	          $('.province-select:visible').val(selected_province);
					} else {
						$('.province-input').show().attr('disabled', false);
						$('.province-select').hide().attr('disabled', true);
					}
				} else {
						$('.province-input').show().attr('disabled', false);
						$('.province-select').hide().attr('disabled', true);
				}

			});

			if($('.address-country-option').length) {
				var provinces = $('.address-country-option').find('option').eq(0).data('provinces');

				var urlpath = window.location.pathname;
				if(urlpath.indexOf('/account/orders') > -1) {
					var def = $('.address-country-option').attr('data-default');
					if(def != '') {
						$('.address-country-option').val(def);
						provinces = $('.address-country-option').find('option:selected').eq(0).data('provinces');
					} else {
						provinces = '';
					}
				}

				if(provinces.length > 0) {
					$('.province-select').find('option').remove();
					$('.province-select').show().attr('disabled', false);
					if($('.province-select').attr('data-superdisabled') == '1') {
						$('.province-select').show().attr('disabled', true);
					}
					$('.province-input').hide().attr('disabled', true);
					for(var i in provinces) {
						$('.province-select').append('<option name="'+provinces[i][0]+'">'+provinces[i][0]+'</option>');
					}
					if(urlpath.indexOf('/account/orders') > -1) {
						var def = $('.province-select').attr('data-default');
						$('.province-select').val(def);
					}
				} else {
					$('.province-input').show().attr('disabled', false);
					$('.province-select').hide().attr('disabled', true);
				}

				if(window.location.pathname === '/account/addresses') {
					var hash = window.location.hash;
					if(hash !== '') {
						if(hash !== 'newaddress') {
							setTimeout(function() {
								var selected = $('.address-country-option:visible').data('default');
								console.log('selected', selected);
								$('.address-country-option:visible').val(selected);
								$('.address-country-option:visible').trigger('change');
							}, 500);
						}
					}
					
				}
			}
		},
		orders: function() {
			var orderSectionToggle = $('.toggle-orders');
			orderSectionToggle.on('click', function() {
				var orderSection = $('.my-account-orders');
				var accountSection = $('.my-account-all');
				orderSection.toggleClass('hide');
				accountSection.toggleClass('hide');
				return false;
			});
		},
    reservations: function() {
      var orderSectionToggle = $('.toggle-reservations');
      orderSectionToggle.on('click', function() {
        var orderSection = $('.my-account-reservations');
        var accountSection = $('.my-account-all');
        orderSection.toggleClass('hide');
        accountSection.toggleClass('hide');
        return false;
      });
    }
	};

	$(function () {
		ald.init();
	});

})(jQuery);
